<template>
	<div class="flex flex-row justify-content-between align-items-center m-2 bg-grey">
		<div class="flex flex-row align-items-center">
			<div class="pi pi-circle-fill text-xs mr-2" />
			<span class="mr-2">Theme:</span>
			<PSelectButton
				:allowEmpty="false"
				:options="options"
				@click="save()"
				aria-labelledby="basic"
				v-model="option"
			/>
		</div>
		<!-- <PButton
			label="Save"
			text
		/>-->
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'
	import Constants from '@/helpers/Constants'
	import PB from '@/brokers/PersistencyBroker'
	import Utils from '@/utils/Utils'
	import EventBus from '@/utils/EventBus'

	export default defineComponent({
		components: {
		},

		data() {
			return {
				before: '',
				option: 'Dark',
				currentTheme: 'aura-dark-teal',
				nextTheme: 'aura-light-blue',
				options: [
					'Dark',
					'Light',
				]
			}
		},

		created() {
			const option = PB.get(Constants.LOCAL_STORAGE_IDS.THEME)
			this.option = option ? option : 'Dark'
			this.before = this.option

			if (this.option !== 'Dark') {
				this.currentTheme = 'aura-dark-teal'
				this.nextTheme = 'aura-light-blue'
			}
		},

		methods: {
			save() {
				if (this.option != this.before) {
					EventBus.emit(Constants.EVENTS.THEME_CHANGED, this.option)
					PB.set(Constants.LOCAL_STORAGE_IDS.THEME, this.option)
					Utils.showSuccessMessage('Settings have been saved succcessfully.')
					this.before = this.option
				}
			}
		}
	})
</script>

<style scoped>
</style>
